<template>
    <div>
        <div class="preview" v-bind:class="{['preview-'+type]:type}" v-if="preview&&(showPreview||value)">
            <img v-bind:src="imagePreview"/>
        </div>
        <div class="input image-input" v-bind:class="{['input-'+width]: width}" v-if="type==='image'">
            <div v-if="showPreview">
                <div class="preview">
                    <div class="image-wrapper">
                      <video v-bind:src="imagePreview" v-if="mime === 'video'" controls />
                      <img v-bind:src="imagePreview" v-if="mime === 'image'"/>
                    </div>
                    <label class="remove-image button" v-on:click="reset">
                        <svgicon name="delete"></svgicon>
                    </label>
                    <label class="edit-image button">
                        <svgicon name="edit"></svgicon>
                        <input type="file" ref="file" v-on:change="onChange" accept=".jpg, .png, .jpeg, .gif, .MP4" class="imageinput" />
                    </label>
                </div>

            </div>
            <div v-else>
                <label class="placeholder">
                    <input type="file" ref="file" v-on:change="onChange" accept=".jpg, .png, .jpeg, .gif, .mp4" class="imageinput" />
                    <svgicon name="image" width="3rem" height="3rem"></svgicon>
                </label>
            </div>
        </div>
        <div class="input file-input" v-bind:class="{['input-'+width]: width}" v-else-if="type==='avatar'">
            <label>
                <input type="file" ref="file" v-on:change="onChange" accept=".jpg, .png, .jpeg, .gif" class="inputfile" />
                Kies een bestand
            </label>
        </div>
        <div class="input file-input" v-else>
            <label>
                <input type="file" name="file" id="file" class="inputfile" />
                Kies een bestand
            </label>
        </div>
    </div>
</template>
<script>
    import Uploader from '@/utils/Uploader';

    export default {
        name: 'FileInput',
        components: {
        },
        props: {
            width: {
                type: String,
                default: 'expand'
            },
            value: {
            },
            preview: {
                type: Boolean
            },
            type: {
                type: String
            },
            accept: {
                type: String,
                default: "*"
            },
            disabled: {
                type: Boolean,
                default: false
            },
            invalid: {
                type: Boolean,
                default: false
            },
            errormessage: {
                type: String,
            },
        },
        data () {
            return {
                file: '',
                mime: '',
                showPreview: false,
                imagePreview: ''
            }
        },
        computed: {
            val: {
                // getter
                get: function () {
                    return this.value
                },
                // setter
                set: function (newValue) {
                    this.$emit('input', newValue);
                }
            }
        },
        mounted () {
            if(this.value){
                this.imagePreview = this.value;
            }
        },
        methods: {
          reset() {
            this.imagePreview = '';
            this.mime = '';
            this.showPreview = false;
          },

          onChange(){
            Uploader(this.$refs.file.files[0]).then(result => {
              this.imagePreview = result.url;
              this.mime = result.type;
              this.showPreview = ['image','video'].includes(result.type);

              this.$emit('input', { url: result.url, type: result.type });
            });
          }
        }
    }

</script>
<style src="./FileInput.scss" lang="scss"></style>
